import { Table, Space } from 'antd'
import { FC, useEffect, useRef, useState } from 'react'

import { Badges, HallOfFame, HeaderTabs } from '../'
import { BitazzaText, Spinner } from '../../../../components'
import { arrayMove } from '../../../../util/arrayMethods'
import { formatNumber } from '../../../../util/formatNumber'
import { getColor } from '../../../../util/getColor'
import { HeaderBadges } from '../HeaderBadges'
import { UserRank } from '../UserRank/UserRank'
import Styles from './Top100.module.scss'
import scrollIntoView from 'scroll-into-view'
import { SVGs } from '../../../../assets'
import { useMediaQuery } from 'react-responsive'
import { IMGs } from '../../../../assets/img'

interface Props {
    rank?: LeaderBoardData[] | []
    user?: usersDataType
    notTop3?: boolean
    onSearchUserTag?: (value: string) => void
    searchResults?: LeaderBoardData[] | []
    status: string
    hallOfFame?: hallOfFame[][]
    selectedTime: string
    setIsLeaderModalOpen: (value: boolean) => void
    OnSelectedRankTab: (value: string) => void
    selectedRankTab: string
    isTop100Loading: (value: boolean) => void
}

type tableType = {
    rank: number
    name: string
    pnl: string
    type: string
    id: number
}
export const Top100: FC<Props> = ({
    rank,
    user,
    notTop3,
    onSearchUserTag,
    searchResults,
    status,
    selectedRankTab,
    selectedTime,
    setIsLeaderModalOpen,
    OnSelectedRankTab,
    hallOfFame,
    isTop100Loading,
}) => {
    const debounceTimeout = useRef<NodeJS.Timeout | null>(null)
    const [data, setData] = useState<tableType[]>([])
    const [loading, setLoading] = useState(true)
    const [shouldScroll, setShouldScroll] = useState<boolean>(false)
    const [searchText, setSearchText] = useState<string>('')
    const [scrollTable, setScrollTable] = useState<number>(398)
    const [tableData, setTableData] = useState<
        LeaderBoardData[] | [] | undefined
    >([])
    const futureUserId = localStorage.getItem('FUTURE_USER_ID')

    const isDesktop = useMediaQuery({ minWidth: 768 })
    const columns = [
        {
            title: 'Rank',
            dataIndex: 'rank',
            key: 'rank',
            width: isDesktop ? '8%' : '14%',
            render(text: string) {
                return (
                    <BitazzaText
                        content={text ? text : 'N/A'}
                        color="#fff"
                        format={isDesktop ? 't16' : 't14'}
                        noWrap
                    />
                )
            },
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            width: isDesktop ? '48%' : '60%',
            render(text: string, record: any) {
                return (
                    <div className={Styles.containerSecondTable}>
                        <div
                            className={
                                user &&
                                user.rank === record.rank &&
                                user.rank !== null
                                    ? `${Styles.tableName} ${Styles.scrollrow}`
                                    : Styles.tableName
                            }
                        >
                            <Badges type={record.type} table />
                            <BitazzaText
                                content={text}
                                color="#ffffffbf"
                                format={isDesktop ? 't16' : 't14'}
                                bold={isDesktop ? true : undefined}
                            />
                        </div>
                    </div>
                )
            },
        },
        {
            title: '% PNL',
            dataIndex: 'pnl',
            key: 'pnl',
            render(text: number) {
                return (
                    <div className={Styles.pnlWrapper}>
                        <BitazzaText
                            content={`${formatNumber(
                                +text,
                                false,
                                true,
                                true,
                                false
                            )}%`}
                            color={getColor(+text, true)}
                            format={isDesktop ? 't16' : 't14'}
                            strong
                            noWrap
                        />
                    </div>
                )
            },
        },
    ]

    useEffect(() => {
        setLoading(true)
        const sliceNumber = notTop3 ? 0 : 3
        const timer = setTimeout(() => {
            if (tableData) {
                setData(
                    tableData
                        .slice(sliceNumber, tableData.length)
                        .map((row) => {
                            const pnl: any = row.pnl_percent
                            return {
                                key: row.rank,
                                rank: row.rank,
                                name: `@${row.btz_id}`,
                                pnl: pnl,
                                type: 'default',
                                id: +row.btz_id,
                            }
                        })
                )
            }
            setLoading(false)
        }, 800)
        return () => clearTimeout(timer)

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tableData, rank, notTop3])

    useEffect(() => {
        if (!searchText) {
            setTableData(rank)
        }
    }, [rank, tableData])

    useEffect(() => {
        setSearchText('')
        setData([])
        setShouldScroll(false)
        handleScroll()
    }, [selectedRankTab, selectedTime])

    useEffect(() => {
        isTop100Loading(loading)
    }, [loading])

    const handleScroll = () => {
        const rows = document.querySelector('.scroll-row') as any
        scrollIntoView(rows, {
            align: {
                topOffset: 10,
            },
        })
    }

    useEffect(() => {
        if (shouldScroll && notTop3) {
            handleScroll()
        }
    }, [shouldScroll, notTop3])

    const handleRowClassName = (record: tableType) => {
        if (user && user.rank === record.rank && user.rank !== null) {
            setTimeout(() => setShouldScroll(true), 100)
            return 'main-row scroll-row'
        } else {
            return 'main-row'
        }
    }

    useEffect(() => {
        searchResults && setTableData(searchResults)
    }, [searchResults])

    const onSearch = () => {
        onSearchUserTag && onSearchUserTag(searchText)
    }

    useEffect(() => {
        if (searchText) {
            setLoading(true)
            setData([])
            onChangeSearchDebounceHandler(searchText)
        } else {
            setTableData(rank)
        }
    }, [searchText])

    const onChangeHandler = (value: string) => {
        setSearchText(value)
    }

    const onChangeSearchDebounceHandler = (value: string) => {
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current)
        }

        debounceTimeout.current = setTimeout(() => {
            if (value.length > 1) {
                onSearchUserTag && onSearchUserTag(value)
            }
        }, 600)
    }
    const calculateResizeValue = () => {
        if (isDesktop) {
            if (!user) {
                return 180 //252-72
            } else {
                return selectedRankTab === 'myRanking' ? 332 : 252
            }
        }
        //Mobile
        else {
            if (!user) {
                return selectedTime === 'monthly' ? 108 : 64
            } else {
                if (selectedTime === 'monthly') {
                    return selectedRankTab === 'myRanking' ? 232 : 172
                }
                //all time
                else {
                    return selectedRankTab === 'myRanking' ? 200 : 148
                }
            }
        }
    }

    useEffect(() => {
        const handleResize = () => {
            const value = calculateResizeValue()

            const plusValue = !isDesktop ? 70 : 0
            const height = window.innerHeight - (value + plusValue)
            setScrollTable(height)
        }

        // Initial height calculation
        handleResize()

        // Update the height on window resize
        window.addEventListener('resize', handleResize)

        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [selectedRankTab, selectedTime, isDesktop, user])

    const locale = {
        emptyText: (
            <Space direction="vertical" size={8} style={{ width: '100%' }}>
                {status !== 'pending' && !loading && searchText ? (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            paddingTop: isDesktop ? undefined : '10%',
                        }}
                    >
                        <Space
                            direction="vertical"
                            style={{ alignItems: 'center' }}
                        >
                            {' '}
                            <img
                                src={SVGs.searchNotFound}
                                alt="Search Not Found"
                                width={isDesktop ? 180 : 120}
                            />
                            <BitazzaText
                                content="No traders found"
                                format="t14"
                                bold={!isDesktop}
                                color={
                                    isDesktop
                                        ? 'rgba(255, 255, 255, 0.75)'
                                        : 'rgba(255, 255, 255, 0.95)'
                                }
                            />
                        </Space>
                    </div>
                ) : (
                    <Spinner />
                )}
            </Space>
        ),
    }

    return (
        <div
            style={
                !notTop3 && isDesktop
                    ? {
                          backgroundImage: `url(${IMGs.Glowing})`,
                          backgroundSize: '1600px 600px',
                          backgroundPosition: 'top',
                          backgroundRepeat: 'no-repeat',
                      }
                    : {}
            }
        >
            {selectedTime === 'monthly' && !isDesktop ? (
                <BitazzaText
                    style={{ paddingBottom: '12px' }}
                    textAlign="center"
                    content="Monthly rankings reset every end of the month. "
                    color="rgba(255, 255, 255, 0.75)"
                />
            ) : null}
            <HeaderTabs
                onTabChangeHandler={(type) => OnSelectedRankTab(type)}
                selectedTab={selectedRankTab}
                onLeaderBoardHandler={() => setIsLeaderModalOpen(true)}
                selectedTime={selectedTime}
                onChangeSearchHandler={onChangeHandler}
                onSearch={onSearch}
                isUserExist={!!user}
                searchText={searchText}
            />
            <div
                className={
                    selectedRankTab === 'top100'
                        ? Styles.noVisableScrollbar
                        : undefined
                }
            >
                <div
                    style={{
                        display: isDesktop ? 'flex' : undefined,
                        flexDirection: isDesktop ? 'column' : undefined,
                        gap: isDesktop ? '0px' : undefined,
                        maxWidth:
                            selectedRankTab === 'top100' ? '800px' : '824px',
                        // height: `calc(100dvh + 112px)`,
                        margin: 'auto',
                        maxHeight: `calc(100dvh - ${
                            user
                                ? selectedTime === 'monthly'
                                    ? isDesktop
                                        ? 198
                                        : 198
                                    : isDesktop
                                    ? 198
                                    : 160
                                : selectedTime === 'monthly'
                                ? isDesktop
                                    ? 116
                                    : 124
                                : isDesktop
                                ? 116
                                : 84
                        }px + ${
                            selectedRankTab === 'hallOfFame' && isDesktop
                                ? 16
                                : 0
                        }px)`,
                        paddingTop:
                            selectedRankTab === 'hallOfFame'
                                ? '20px'
                                : selectedRankTab === 'myRanking'
                                ? isDesktop
                                    ? '80px'
                                    : '10px'
                                : isDesktop
                                ? '32px'
                                : '0px',
                        overflowY:
                            selectedRankTab === 'top100' ? 'scroll' : undefined,
                    }}
                >
                    {selectedRankTab === 'hallOfFame' && hallOfFame ? (
                        <HallOfFame
                            data={hallOfFame}
                            selectedTime={selectedTime}
                        />
                    ) : rank &&
                      rank.length &&
                      status !== 'pending' &&
                      !loading ? (
                        <>
                            {!notTop3 ? (
                                <HeaderBadges
                                    selectedTime={selectedTime}
                                    data={arrayMove(rank.slice(0, 3), 0, 1)}
                                    isDesktop={isDesktop}
                                />
                            ) : null}

                            {/* <div style={{ height: `calc(100dvh - 112px - 200px - 32px)`, width: '100%', backgroundColor: 'red' }}>
                            1
                        </div> */}
                            {/* <div style={{ height: '40vh', overflowY: 'scroll' }}>
                            {data && data.map((item, index) => (
                                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '32px' }} key={index}>
                                    <div style={{ color: 'white' }}>
                                        {item.rank}
                                    </div>
                                    <div style={{ color: 'white' }}>
                                        {item.name}
                                    </div>
                                    <div style={{ color: 'white' }}>
                                        {item.pnl}
                                    </div>
                                </div>
                            ))}
                        </div> */}
                            <div style={{ height: '100%' }}>
                                <Table
                                    className={Styles.table}
                                    bordered={false}
                                    rowClassName={(record) =>
                                        handleRowClassName(record)
                                    }
                                    dataSource={data}
                                    columns={columns}
                                    showHeader={data.length ? true : false}
                                    pagination={false}
                                    scroll={{ y: scrollTable }}
                                    locale={locale}
                                />
                            </div>

                            {user &&
                            data.length !== 0 &&
                            futureUserId !== null ? (
                                <UserRank
                                    name={user?.btz_id}
                                    tier={''}
                                    score={user?.pnl_percent?.toString() || ''}
                                    rank={user.rank || 'N/A'}
                                    selectedRankTab={selectedRankTab}
                                />
                            ) : null}
                        </>
                    ) : (
                        <Spinner />
                    )}
                </div>
            </div>
        </div>
    )
}
